import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { Hero } from "@/components/landing/Hero";
import { HowItWorks, Features } from "@/components/landing/Sections";
import { DemoArea } from "@/components/landing/DemoArea";
import { Pricing } from "@/components/landing/Pricing";

export default function Landing() {
  return (
    <div className="min-h-screen overflow-x-hidden" data-testid="landing-page">
      <Header landing />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <DemoArea />
        <Pricing />
      </main>
      <Footer />
    </div>
  );
}
